import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const manager_login = (code, temp_token) => {
  // 登录验证时不需要 token，使用单独的配置避免拦截器添加 token
  return api.post(
    `${ApiEndpointConstants.MANAGERLOGIN}`,
    { code, temp_token },
    {
      // 跳过 token 拦截器，因为这是登录验证请求
      skipAuth: true,
    }
  );
};
